import { Carrito } from './../classes/carrito';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class OrderService {
  
  // Array
  public OrderDetails;
  public total;

  constructor(private router: Router) { }

  // Get order items
  public getOrderItems(): Carrito {
    return this.OrderDetails;
  }

  public getTotal(): number {
    return this.total;
  }
}
